var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0.336072 0.336799C0.5218 0.15079 0.82304 0.150677 1.00891 0.336545L13.6622 12.9899C13.8481 13.1757 13.8482 13.4772 13.6625 13.6632C13.4768 13.8492 13.1755 13.8493 12.9896 13.6635L0.336325 1.01014C0.150456 0.824274 0.150343 0.522808 0.336072 0.336799Z","fill":"white","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13.6625 0.336799C13.4767 0.15079 13.1755 0.150677 12.9896 0.336545L0.336308 12.9899C0.15044 13.1757 0.150326 13.4772 0.336055 13.6632C0.521784 13.8492 0.823023 13.8493 1.00889 13.6635L13.6622 1.01014C13.8481 0.824274 13.8482 0.522808 13.6625 0.336799Z","fill":"white","key":1})]);
}

Close.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = Close;

Close.default = Close;
